module.exports = __webpack_public_path__ + "img/self_styling_mw_02.096588cf.jpg";